import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'ssi_user_token';
const USER_KEY = 'ssi_user';

const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const userAuth = {
  async login(email, password) {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(res.data.user));
    return res.data;
  },
  async register({ email, password, first_name, last_name, phone }) {
    const res = await api.post('/auth/register', { email, password, first_name, last_name, phone });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(USER_KEY, JSON.stringify(res.data.user));
    return res.data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  getUser() {
    try {
      const raw = localStorage.getItem(USER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  isAuthenticated() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
  api,
};

export const customerApi = {
  myReservations: () => api.get('/me/reservations').then(r => r.data),
  myReservation: (id) => api.get(`/me/reservations/${id}`).then(r => r.data),
  updateReservation: (id, body) => api.patch(`/me/reservations/${id}`, body).then(r => r.data),
  requestCancel: (id) => api.post(`/me/reservations/${id}/request-cancel`).then(r => r.data),
  getSchool: (schoolId) => api.get(`/schools/${schoolId}`).then(r => r.data),
};
